const { getWindowHeight } = require("../utils");
const Scroller = require("./scroller");

class ScrollNotification {
  static show(elm) {
    const components = document.getElementsByClassName("scroll-notification");
    if (!components) return;
    const component = components[0];
    if (!component) return;

    const height = getWindowHeight();

    component.innerHTML =  getLngTxt("scrollmore");
    
    component.classList.add("scroll-notification-active");
    component.onclick = function() {
      const bound = elm.getBoundingClientRect();
      Scroller.smoothScrollTo(window.pageYOffset + 300, 400);
    };
  }

  static hide() {
    const components = document.getElementsByClassName("scroll-notification");
    if (!components) return;
    const component = components[0];
    if (!component) return;

    component.classList.remove("scroll-notification-active");
  }

  static attachElement(elm) {
    ScrollNotification.elements.push(elm);
  }

  static init() {
    const height = getWindowHeight();
    ScrollNotification.elements = [];

    window.addEventListener("scroll", function(e) {
      const scrollY = window.scrollY;
      let showNotification = false;
      let element = null;

      for (var p in ScrollNotification.elements) {
        const elm = ScrollNotification.elements[p];
        const bound = elm.getBoundingClientRect();
        const offsetTop = elm.offsetTop;

        const defOffset = typeof elm.defaultOffset !== 'undefined' ? elm.defaultOffset : 75;
        if (
          scrollY + height / 2 > offsetTop &&
          scrollY + height - defOffset < offsetTop + bound.height - 220
        ) {
          showNotification = true;
          element = elm;
        }
      }

      if (showNotification) {
        ScrollNotification.show(element);
      } else {
        ScrollNotification.hide();
      }
    });
  }
}

module.exports = ScrollNotification;
